var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-slider', _vm._b({
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.score,
      callback: function ($$v) {
        _vm.score = $$v;
      },
      expression: "score"
    }
  }, 'v-slider', Object.assign({}, _vm.$attrs, {
    color: _vm.color,
    trackColor: _vm.trackColor,
    trackFillColor: _vm.trackFillColor
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }